import React, {useContext, useEffect, useState} from "react";
import BookingHeroComponent from "./BookingHero.component";
import BookingHeaderComponent from "./BookingHeader.component";
import BookingSchedulerComponent from "./BookingScheduler.component";
import BookingSuccessComponent from "./BookingSuccess.component";
import BookingService from "../services/BookingService";
import LoadingComponent from "../../forms/components/LoadingComponent/LoadingComponent";
import {AuthContext} from "../../member/components/AuthContext";
import {withNamespaces} from "react-i18next";

const promoOverride = new URLSearchParams(window.location.search).get('pt_promo') === 'true';

const BookingComponent = (props) => {
  const [success, setSuccess] = useState({success: false, event: {}, slot: {}, focusArea: null});
  const { member } = useContext(AuthContext);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);

  const isTrainerDay = window.location.pathname.includes('training-day');
  const basePath = isTrainerDay ? '/booking/training-day' : '/booking/crunchone';
  const eventType = isTrainerDay ? 'training-day' : 'crunchone';
  const isPromotion = promoOverride || !!(data && data.ptPromoActive);

  useEffect(() => {
    setLoading(true);
    BookingService.getEventWithSlots(basePath).then(data => {
      if (data.booking) {
        setSuccess({success: true, event: data.event, slot: data.booking, focusArea: data.booking.parameters && data.booking.parameters.focus_area});
      } else {
        setData(data);
      }
    }).finally(() => setLoading(false));
  }, []);

  const isOpenOrComingSoon = ['open', 'coming_soon'].includes(member.club.status);
  const isComingSoon = member.club.status === 'coming_soon';
  const noAvailability = !!(data && (!data.availability || data.availability.length === 0));
  const allowPreSale = !!(isComingSoon && data && data.addon && noAvailability);
  const ptClientBlocked = isTrainerDay && data && data.isPtClient;
  const isNotAvailable = (d) => {
    if (!d) return false;
    if (d.event && d.event.shouldBuy() && !d.addon) return true;
    if (noAvailability && !allowPreSale) return true;
    return false;
  };
  const notAvailable = !isOpenOrComingSoon || isNotAvailable(data) || ptClientBlocked;

  return (
    <div className='booking-coko'>
      {loading && <LoadingComponent isVisible={loading}>
        <p className="checkout-loader-wait-text">
          { props.t('booking_loading_trainers_line1') }
          <br/>
          { props.t('booking_loading_trainers_line2') }
        </p>
      </LoadingComponent> }
      {success.success && member && (
        <BookingSuccessComponent
          slot={success.slot}
          event={success.event}
          member={member}
          eventType={eventType}
          focusArea={success.focusArea}
          preSale={allowPreSale}/>
      )}
      {!success.success && data && (
        <React.Fragment>
          <BookingHeroComponent eventType={eventType} isPromotion={isPromotion} />

          {notAvailable ? (
            <div className='booking-scheduler-not-available'>
              <h3>{props.t(
                ptClientBlocked
                  ? 'trainer_day_pt_client_error'
                  : !isOpenOrComingSoon
                    ? (isTrainerDay ? 'trainer_day_for_club_not_available_header' : 'booking_for_club_not_available_header')
                    : (isTrainerDay ? 'trainer_day_not_available_header' : 'booking_not_available_header')
              )}</h3>
              <a href="/" className='form-main-button'>
                {props.t('booking_not_available_cta')}
              </a>
            </div>
          ) : (
            <React.Fragment>
              <BookingHeaderComponent addon={data.addon} eventType={eventType} isPromotion={isPromotion} />
              <BookingSchedulerComponent
                onSuccess={(result) => setSuccess(result)}
                event={data.event}
                availability={data.availability}
                addon={data.addon}
                allowPreSale={allowPreSale}
                card={member.default_card}
                eventType={eventType}
                basePath={basePath}
                trainerDayDate={data.trainerDayDate}
                focusEnabled={data.focusEnabled}
                ptPromoEnabled={data.ptPromoEnabled}
                allowChangeCard={member && Date.now() - member.created_at.getTime() > 1000 * 60 * 60 * 2} />
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </div>
  );
};

BookingComponent.propTypes = {
}

export default withNamespaces()(BookingComponent);